import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../core/service/v2/abstractRepositoryV2';
import {ProductRetrocessionModel} from '../../../api/entity/productRetrocession.model';

@Injectable()
export class ProductRetrocessionRepository extends AbstractRepositoryV2<ProductRetrocessionModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('ProductRetrocession', serviceElementsFactory, injector);
    }
}
